export const ANNOUNCEMENTS_ROUTES = {
  __ROOT__: '/announcements',
}